import { useNavigate } from "react-router-dom";
import { Topbar } from "../ui/Topbar";
import { usePortfolio } from "../features/portfolio/usePortfolio";
import { SummaryCards } from "../features/portfolio/SummaryCards";
import { PortfolioTable } from "../features/portfolio/PortfolioTable";
import { useScrollRestore } from "../lib/useScrollRestore";

export default function Portfolio() {
  const portfolio = usePortfolio();
  const navigate = useNavigate();
  const scrollRef = useScrollRestore<HTMLDivElement>("portfolio");

  return (
    <>
      <Topbar title="Мой портфель" />

      {portfolio.isError && (
        <div className="banner error">
          ошибка: {String(portfolio.error)}
        </div>
      )}

      <SummaryCards summary={portfolio.data?.summary} />

      {portfolio.data &&
        (portfolio.data.positions.length === 0 ? (
          <div className="banner">
            нет открытых позиций — найди бумагу в скринере, открой карточку и
            нажми «+ В портфель»
          </div>
        ) : (
          <div ref={scrollRef} className="page-scroll">
            <PortfolioTable
              rows={portfolio.data.positions}
              onPick={(secid) => navigate(`/bond/${secid}`)}
            />
          </div>
        ))}
    </>
  );
}
